const projectsRoot = (root: string) => () => `${root}/projects`;

const createNew = (root: string) => () => `${projectsRoot(root)()}/add`;

const details = (root: string) => () => `${projectsRoot(root)()}/:id/details`;

const monitors = (root: string) => () => `${projectsRoot(root)()}/:id/monitors`;

const access = (root: string) => () => `${projectsRoot(root)()}/:id/access`;

export const configurationProjectsRoutes = (root: string) => ({
  root: projectsRoot(root),
  createNew: createNew(root),
  details: details(root),
  monitors: monitors(root),
  access: access(root),
});
